import '_base.scss';
import '@cargomatic/ui/base.css';
import '@cargomatic/ui/fonts.css';
import '@cargomatic/ui/global.css';
import 'styles.css';
import './utils/sentry';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import Dom from 'react-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import Command from 'components/command';
import LoadingCircle from 'components/ui/LoadingCircle';
import './i18n';
import { LocaleContextProvider } from './providers/locale-settings-context';
import LaunchDarklyWrapper from 'components/LaunchDarklyWrapper';
import PostHogWrapper from 'components/PostHogWrapper';

const queryClient = new QueryClient();

Dom.render(
  <APIProvider
    apiKey={GOOGLE_MAPS_KEY}
    version="3.64"
    libraries={['places', 'drawing', 'geometry']}
  >
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<LoadingCircle />}>
        <LaunchDarklyWrapper>
          <PostHogWrapper>
            <LocaleContextProvider>
              <Command />
            </LocaleContextProvider>
          </PostHogWrapper>
        </LaunchDarklyWrapper>
      </Suspense>
    </QueryClientProvider>
  </APIProvider>,

  document.getElementById('content'),
);
